"use client";
import { useEffect } from "react";
import ContentstackLivePreview from "@contentstack/live-preview-utils";
import {LIVE_PREVIEW_SETTINGS} from "@/constants/contentStackConstants";

export default function LivePreviewInit(props) {
  useEffect(() => {
    ContentstackLivePreview.init({
      enable:LIVE_PREVIEW_SETTINGS?.enable,
      mode: LIVE_PREVIEW_SETTINGS?.mode,
      ssr: LIVE_PREVIEW_SETTINGS?.ssr,
      editButton: {
        enable: LIVE_PREVIEW_SETTINGS?.editButtonEnable,
        exclude: LIVE_PREVIEW_SETTINGS?.editButtonExclude,
        includeByQueryParameter: LIVE_PREVIEW_SETTINGS?.editButtonIncludeByQueryParameter,
        position:  LIVE_PREVIEW_SETTINGS?.editButtonPosition
      },
      editInVisualBuilderButton: {
        enable: LIVE_PREVIEW_SETTINGS?.editInVisualBuilderButtonEnable,
      },
      stackDetails: {
        apiKey: props?.apiKey ,
        environment: props?.envKey,
      },
      
    });
  }, [props]);
  return null;
}
